import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/fonts';
import './styles/tokens.css';
import './index.css';
import './ui/ui.css';
import './shell/shell.css';
import './styles/screens.css';
import './styles/settings.css';
import './styles/item.css';
import './i18n';
import AuthGate from './auth/AuthGate';
import { UIProvider } from './ui';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <UIProvider>
        <AuthGate />
      </UIProvider>
    </BrowserRouter>
  </React.StrictMode>
);
